import { useVariantIds } from "hooks/useVariantIds";
import { useDiscounts } from "lib/apollo/hooks";
import type { BasketByLimit, BasketByType } from "@shared/graphql.apollo";
import { useMemo } from "react";
import { getBasketByLimit } from "./utils/getBasketByLimit";

export const useBasketByLimit = (
  bucketedBasket: BasketByType
): BasketByLimit => {
  const { giftMembershipProductId } = useVariantIds();
  const discounts = useDiscounts();
  return useMemo(() => {
    return getBasketByLimit(bucketedBasket);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bucketedBasket, giftMembershipProductId, discounts]);
};
